import { render, staticRenderFns } from "./AppExampleAnt.vue?vue&type=template&id=835334bc&"
import script from "./AppExampleAnt.vue?vue&type=script&lang=js&"
export * from "./AppExampleAnt.vue?vue&type=script&lang=js&"
import style0 from "./AppExampleAnt.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports